module.exports = __webpack_public_path__ + "static/media/logo.d3cd5ef4.svg";